module.exports = __webpack_public_path__ + "static/media/pet-race-hamster.1f909bcb.svg";